<template>
  <div class="h-full overflow-hidden">
    <el-table :data="wholePersonData" border stripe class="mt-20px" :height="tableHeight">
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="年龄" prop="age" show-overflow-tooltip></el-table-column>
      <el-table-column label="学历" prop="educationName" show-overflow-tooltip></el-table-column>
      <el-table-column label="工作年限" prop="workYear" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.workYear ? scope.row.workYear + '年' : '' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="主要工作经历"
        prop="WorkDescription"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column label="技能证书" prop="certificates" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column> -->
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="gotoDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="wholePersonTableSizeChange"
      @current-change="wholePersonableCurrentChange"
      :current-page.sync="wholePersonPageConfig.SkipCount"
      :page-size.sync="wholePersonPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="wholePersonPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
  </div>
</template>
<script>
import { ContractorPersonnelApi } from '@wiz-api/contractor-management'
import utils from '@/components/safety/enumField/utils'

const contractorPersonnelApi = new ContractorPersonnelApi()
export default {
  props: {
    contractorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      wholePersonData: [],
      wholePersonPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
      educationList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 75px)'
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  async created() {
    await utils.getDataCategory(
      ['ContractorManagement.DataCategory.Education'],
      ['educationList'],
      this
    )
    this.getData()
  },
  methods: {
    // 奖励考核信息页码改变
    wholePersonTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    wholePersonableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    async getData() {
      const data = {
        contractorId: this.contractorId,
        maxResultCount: this.wholePersonPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.wholePersonPageConfig.SkipCount - 1) * this.wholePersonPageConfig.MaxResultCount, // 跳过多少条
      }
      if (this.activeName === 'specialPersonal') {
        data.isSpecialOperationCertificatePersonnel = true
      }
      const [err, res] = await contractorPersonnelApi.pagedListQuery(data)
      if (!err) {
        this.wholePersonData = res.items.map((item) => {
          this.educationList.forEach((e) => {
            if (item.education === parseInt(e.code, 10)) {
              item.educationName = e.displayName
            }
          })
          return item
        })

        this.wholePersonPageConfig.totalCount = res.totalCount
      }
    },
    gotoDetail(row) {
      this.$router.push({
        path: `${this.basePath}/contractor-management-sm/personnel-configuration`,
        query: {
          id: row.id,
          pageFrom: 'OneBookOneTeam',
        },
      })
    },
  },
}
</script>
